import axios from 'axios'

// 修改密码
export function changePassword(data) {
  return axios.post(process.env.VUE_APP_BASE_API + '/user/changePassword', data)
}

// 账户注销
export function logoff(data) {
  return axios.post(process.env.VUE_APP_BASE_API + '/user/logoff', data)
}

export default {
  changePassword,
  logoff
}
